module.exports = __webpack_public_path__ + "img/card-verve.8da6eb22.svg";